import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import WithRender from './UpdateMessageTemplateRequest.html';
import { Inject } from 'vue-di-container';
import UpdateMessageTemplateRequestService from './UpdateMessageTemplateRequestService';
import MessageTemplateService from '../MessageTemplateService';
import { DropdownModel } from '../../Provider/ProviderModel';
import { isolateTemplateVariablePlaceholders } from '../../../shared/templateTextDirection';
import CITCKeywordsService from '../../CITCKeywords/CITCKeywordsService';
import ProviderService from '../../Provider/ProviderService';
import { UpdateMessageTemplateModel, SenderViewModel } from './UpdateMessageTemplateModel';
import { SuggestedTemplateModel, TemplateValidationModel } from '../MessageTemplateModel';
import ValidationService from '../../../Services/ValidationService';
import UserService from '../../../shared/userService/UserService';
import UserRoleService from '../../../shared/userService/UserRoleService';
import { Toaster } from '../../../Services/toast';
import { SenderType } from '../../../shared/Enums/SenderType';
import { AttachmentModel } from '../../AddRequest/AttachmentModel';
import { AttachmentCategoryType } from '../../../shared/Enums/AttachmentCategory';
import { TemplateVariableValidation } from '../../../shared/templateVariableValidation';
import { AxiosError } from 'axios';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        UpdateMessageTemplateRequestService,
        MessageTemplateService,
        CITCKeywordsService,
        ProviderService,
    ],
})
export default class UpdateMessageTemplateRequest extends Vue {
    @Inject(ValidationService) public validationService!: ValidationService;
    @Inject(UpdateMessageTemplateRequestService) public UpdateContractRequestService!: UpdateMessageTemplateRequestService;
    @Inject(MessageTemplateService) public messageTemplateService!: MessageTemplateService;
    @Inject(CITCKeywordsService) public cITCKeywordsService!: CITCKeywordsService;
    @Inject(ProviderService) public providerService!: ProviderService;
    @Inject(UserService) public userService!: UserService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;

    @Prop({ default: 0 })
    public id!: string;

    public minDate: Date = new Date();
    public stepNumber: number = 1;
    public templateTextDir: string = (typeof localStorage !== 'undefined' && localStorage.dir === 'rtl') ? 'rtl' : 'ltr';
    public userRole: number = 0;

    public setTemplateTextDir(dir: string): void {
        this.templateTextDir = dir === 'rtl' ? 'rtl' : 'ltr';
    }
    public requestStatus: number = 0;
    public senderName: string = '';
    public typeFile: number = 0;
    public senderNameLength: number = 11;
    public contractAttachmentName: string = '';
    public senderType: number[] = [];
    public isVipPackage: boolean = false;
    public expiryDateFromMenu: boolean = false;
    public concatenatedSenderTypes: string = '';
    public sendersList: string[] = [];
    public submitRequestdialog: boolean = false;
    public isSubmitted: boolean = false;
    public isCriticalSender: boolean = false;
    public senderNameId: number = 0;
    public templateVariableExamples: string[] = [];
    public templateVariableMaxLengths: number[] = [];
    public templateVariableTypes: string[] = [];
    public readonly validVariableTypes: string[] = ['Numbers', 'Letters', 'Letters & Numbers', 'Link'];
    public selectedFileName: string = '';
    public currentAttachment: AttachmentModel = {
        id: '',
        fileName: '',
        fileContent: '',
        file: null,
        attachmentType: '',
        attachmentTypeName: '',
        isDeleted: false,
    };
    public responseMessage: string = '';
    public responseSuccess: boolean = false;
    public isAiValid: boolean = false;
    public aiValidationRemarks: string = '';
    public loadingAIValidation: boolean = false;
    public aiValidationProgress: number = 0;
    private aiValidationProgressInterval: any = null;
    public aiContinueDialog: boolean = false;
    private lastValidatedTemplateContent: string = '';
    private lastAiFailureRemarks: string = '';

    public readonly maxLicenseAttachments: number = 3;
    public readonly maxLicenseFileSizeBytes: number = 3000000;
    public readonly totalSteps: number = 2;

    private readonly noActiveRegulationMessage: string = 'No active regulation found for this category';

    public headers: any = [
        { text: this.$t('shared.senderName'), value: 'operatorId', align: 'right', sortable: false },
        { text: this.$t('shared.senderType'), value: 'operatorId', align: 'center', sortable: false },
        { text: this.$t('shared.clientName'), value: 'name', align: 'center', sortable: false }
    ];
    public customerTypeList: DropdownModel[] = [
        { id: 1, name: this.$t('shared.government').toString() },
        { id: 2, name: this.$t('shared.charity').toString() },
        { id: 3, name: this.$t('shared.private').toString() },
        { id: 4, name: this.$t('shared.international').toString() },
    ];
    public allClassifications: DropdownModel[] = [
        { id: 1, name: this.$t('shared.Advertising').toString() },
        { id: 2, name: this.$t('shared.Service').toString() },
        { id: 3, name: this.$t('shared.Warning').toString() },
        { id: 5, name: this.$t('shared.Awareness').toString() },
    ];
    public classification: DropdownModel[] = this.allClassifications;

    private readonly classificationBySenderType: { [key: number]: number[] } = {
        [SenderType.Advertisement]: [1],
        [SenderType.Service]: [2],
        [SenderType.Awareness]: [5],
        [SenderType.Warning]: [3],
    };

    public chanel: DropdownModel[] = [
        { id: 1, name: 'SMS' },
        { id: 2, name: 'Internal Shortcode' },
        { id: 3, name: 'Google RCS' },
    ];
    public templateExpiry: DropdownModel[] = [
        { id: 1, name: this.$t('shared.OneYear').toString() },
    ];
    public senderTypeList: DropdownModel[] = [
        { id: SenderType.Advertisement, name: this.$t('shared.advertisement').toString() },
        { id: SenderType.Service, name: this.$t('shared.service').toString() },
        { id: SenderType.Awareness, name: this.$t('shared.awareness').toString() },
        { id: SenderType.Warning, name: this.$t('shared.warning').toString() },
    ];

    public preApprovedTemplates: SuggestedTemplateModel[] = [];
    public loadingPreApprovedTemplates: boolean = false;
    private loadedSuggestedFreeContentSnapshot: {
        preApprovedTemplateId: string;
        selectedTemplateId: string;
        templateContent: string;
        templateDescription: string;
        templateName: string;
        templateVariableExamples: string[];
        selectedTemplateDescription: string;
    } | null = null;

    public validationModel: TemplateValidationModel = {
        TemplateContent: '',
        Classification: 0,
    };

    public model: UpdateMessageTemplateModel = {
        id: '',
        duration: '1',
        startDate: '',
        clientName: '',
        customerType: 0,
        crNumber: '',
        enterpriseUnifiedNumber: '',
        senderName: '',
        requestType: 7,
        comment: '',
        expiryDate: '',
        senderType: 0,
        isNormalProcessing: true,
        isExpressProcessing: false,
        preApprovedTemplateId: '',
        selectedTemplateId: '',
        senderId: '',
        templateContent: '',
        templateDescription: '',
        templateExpiry: 0,
        templateName: '',
        processingDuration: 0,
        classification: 0,
        companyName: '',
        chanel: 0,
        senderRequestAttachments: [],
    };

    senderNames: SenderViewModel[] = [];
    public selected: SenderViewModel[] = [];
    public selectedIds: string[] = [];

    public get fileNameRef(): HTMLInputElement {
        return this.$refs.fileName as HTMLInputElement;
    }

    public get regulationsPdfUrl(): string {
        const url = (window.$config && window.$config.messageTemplateRegulationsPdfUrl) || '';
        if (!url) {
            return '';
        }
        if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('/')) {
            return url;
        }
        return '/' + url.replace(/^\/+/, '');
    }

    public openRegulationsPdf(event?: Event) {
        if (event) {
            event.preventDefault();
        }
        const url = this.regulationsPdfUrl;
        if (!url) {
            return;
        }
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    public get attachmentTooltip(): string {
        const pdfOnly = this.$t('shared.pdfFilesOnly').toString();
        const maxFiles = this.$t('shared.maxLicenseAttachments').toString();
        const max = this.$t('shared.maxFileSize3MB').toString();
        return [pdfOnly, maxFiles, max].join('\n');
    }

    public get visibleAttachments(): AttachmentModel[] {
        return (this.model.senderRequestAttachments || []).filter((a) => !a.isDeleted);
    }

    public get canUploadMoreLicenseAttachments(): boolean {
        return this.visibleAttachments.length < this.maxLicenseAttachments;
    }

    public get canAddAttachment(): boolean {
        return this.canUploadMoreLicenseAttachments && this.selectedFileName !== '';
    }

    public get isAwarenessClassification(): boolean {
        return this.model.classification === 5;
    }

    public get templateSuffix(): string {
        return this.isAwarenessClassification ? (this.model.companyName || '').trim() : '';
    }

    public get displayTemplateSuffix(): string {
        return this.isAwarenessClassification ? this.templateSuffix : '';
    }

    public get filteredSuggestedTemplates(): SuggestedTemplateModel[] {
        if (!this.model.classification) {
            return [];
        }
        return this.preApprovedTemplates;
    }

    public get isSuggestedFreeContentSelected(): boolean {
        return !!this.model.preApprovedTemplateId;
    }

    public get areVariableActionsDisabled(): boolean {
        return this.isSuggestedFreeContentSelected || this.isAttachmentsOnlyEdit;
    }

    public get fullTemplateContent(): string {
        const base = (this.model.templateContent || '').trim();
        if (this.isSuggestedFreeContentSelected && !this.isAwarenessClassification) {
            return base;
        }
        const orgName = this.templateSuffix;
        if (!orgName) {
            return base;
        }
        if (base.toLowerCase().endsWith(orgName.toLowerCase())) {
            return base;
        }
        return base ? `${base} ${orgName}` : orgName;
    }

    public get substitutedFullContent(): string {
        const base = (this.model.templateContent || '').trim();
        let result = base;
        for (let i = 0; i < this.templateVariableExamples.length; i++) {
            const value = this.templateVariableExamples[i];
            if (value && value.trim()) {
                result = result.replace(new RegExp('#Var' + (i + 1) + '#', 'g'), value.trim());
            }
        }
        return result;
    }

    public get baseTemplateContent(): string {
        return (this.model.templateContent || '').trim();
    }

    public get hasTemplateVariables(): boolean {
        return /#Var\d+#/i.test(this.baseTemplateContent);
    }

    public formatTemplateContentForDisplay(content: string): string {
        return isolateTemplateVariablePlaceholders(content || '');
    }

    public get reviewTemplateVariables(): Array<{ key: string, value: string }> {
        return this.templateVariableExamples.map((example, index) => ({
            key: '#Var' + (index + 1) + '#',
            value: example || '',
        }));
    }

    public get areVariableExamplesValid(): boolean {
        if (!this.templateVariableExamples.length) {
            return true;
        }
        return this.templateVariableExamples.every((value) => value && value.trim() !== '');
    }

    public get isTemplateDescriptionValid(): boolean {
        const description = (this.model.templateDescription || '').trim();
        if (!description) {
            return true;
        }
        return description.length >= 3 && description.length <= 160;
    }

    public get templateDescriptionError(): string {
        const description = (this.model.templateDescription || '').trim();
        if (!description) {
            return '';
        }
        if (description.length < 3) {
            return this.$t('shared.templateDescriptionMinLength').toString();
        }
        if (description.length > 160) {
            return this.$t('shared.templateDescriptionMaxLength').toString();
        }
        return '';
    }

    public get filteredClassifications(): DropdownModel[] {
        let items: DropdownModel[] = this.allClassifications;
        if (this.senderType.length) {
            const allowedIds = new Set<number>();
            this.senderType.forEach((type) => {
                (this.classificationBySenderType[type] || []).forEach((id) => allowedIds.add(id));
            });
            items = this.allClassifications.filter((item) => allowedIds.has(item.id));
        }
        const currentId = this.normalizeClassification(this.model.classification);
        if (currentId && !items.some((item) => item.id === currentId)) {
            const fromAll = this.allClassifications.find((item) => item.id === currentId);
            if (fromAll) {
                items = items.concat([fromAll]);
            } else {
                items = items.concat([{
                    id: currentId,
                    name: this.getClassificationText(currentId),
                }]);
            }
        }
        return items;
    }

    public get templateContentMinimumCharacterCount(): number {
        return this.templateSuffix.length;
    }

    public get templateContentTotalCharacterCount(): number {
        const fullContent = this.fullTemplateContent;
        const suffixSeparatorLength = this.baseTemplateContent && fullContent !== this.baseTemplateContent ? 1 : 0;
        return this.getTemplateContentWithoutVariables(fullContent).length - suffixSeparatorLength;
    }

    public get hasInvalidVariableBoundary(): boolean {
        return this.contentStartsOrEndsWithVariable(this.model.templateContent);
    }

    public get isExpressProcessingHidden(): boolean {
        return !window.$config
            || window.$config.messageTemplateSpeedUpApprovalHide !== false;
    }

    public get speedUpFeeAmount(): number {
        return (window.$config && window.$config.messageTemplateSpeedUpFeeAmount) || 10;
    }

    public get isProviderEditRole(): boolean {
        return this.userRole === 2 || this.userRole === 5;
    }

    public get isPlatformEditRole(): boolean {
        return this.userRole === 1 || this.userRole === 9 || this.userRole === 15;
    }

    public get isPendingPaymentEdit(): boolean {
        return this.isProviderEditRole && this.requestStatus === 7;
    }

    public get isRejectedEdit(): boolean {
        return this.isProviderEditRole && this.requestStatus === 3;
    }

    public get isCompletedEdit(): boolean {
        return this.isPlatformEditRole && this.requestStatus === 8;
    }

    public get isAttachmentsOnlyEdit(): boolean {
        return this.isCompletedEdit;
    }

    public get isProcessingDurationDisabled(): boolean {
        return !this.isRejectedEdit || this.isSuggestedFreeContentSelected || this.isExpressProcessingHidden;
    }

    public get isClassificationDisabled(): boolean {
        return !this.isRejectedEdit || this.isAttachmentsOnlyEdit;
    }

    public get isTemplateDataDisabled(): boolean {
        return this.isAttachmentsOnlyEdit || this.isSuggestedFreeContentSelected;
    }

    private get canSafelyReloadSuggestedFreeContent(): boolean {
        return !this.isClassificationDisabled && !!this.model.classification;
    }

    private contentStartsOrEndsWithVariable(content: string): boolean {
        const trimmed = (content || '').trim();
        if (!trimmed) {
            return false;
        }
        return /^#Var\d+#/i.test(trimmed) || /#Var\d+#$/i.test(trimmed);
    }

    public isSuggestedTemplateSelected(template: SuggestedTemplateModel): boolean {
        if (!this.isSuggestedFreeContentSelected || !this.model.selectedTemplateId) {
            return false;
        }
        return String(this.model.selectedTemplateId) === String(template.id);
    }

    public get isSuggestedTemplateSelectionDisabled(): boolean {
        return this.isAttachmentsOnlyEdit;
    }

    public async created() {
        this.$emit('childinit', this.layoutSup);
        const user = await this.userService.getUser();
        this.userRole = this.userRoleService.GetUserRole(user);
        const providerId = user.details.ProviderId;
        const provider = await this.providerService.GetById(providerId);
        if (!provider.hasInternational) {
            this.customerTypeList.splice(3, 1);
        }
        this.isVipPackage = !!(window.$config && window.$config.messageTemplateVipPackage === true);
        const response = await this.UpdateContractRequestService.get(this.id);
        if (response.isSuccess) {
            const result = response.result || {};
            const rawPreApproved = result.preApprovedTemplateId || result.PreApprovedTemplateId || '';
            const preApprovedTemplateId = this.normalizePreApprovedTemplateId(rawPreApproved);
            const attachmentsRaw = result.senderRequestAttachments || result.SenderRequestAttachments || [];
            const processingDuration = result.processingDurationType != null
                ? result.processingDurationType
                : (result.ProcessingDurationType != null
                    ? result.ProcessingDurationType
                    : (result.processingDuration != null ? result.processingDuration : 1));
            const classification = this.normalizeClassification(
                result.classification != null ? result.classification : result.Classification,
            );
            const senderType = this.normalizeSenderTypeFlags(
                result.senderType != null ? result.senderType : result.SenderType,
            );
            this.model = {
                ...this.model,
                ...result,
                classification,
                senderType,
                preApprovedTemplateId,
                selectedTemplateId: result.selectedTemplateId || preApprovedTemplateId || '',
                processingDuration: Number(processingDuration) || 1,
                senderRequestAttachments: attachmentsRaw.map((a: any) => ({
                    id: a.id || a.Id || '',
                    fileName: a.fileName || a.FileName || '',
                    fileContent: a.fileContent || a.FileContent || '',
                    file: null,
                    attachmentType: a.attachmentType || a.AttachmentType || AttachmentCategoryType.Other,
                    attachmentTypeName: a.attachmentTypeName || a.AttachmentTypeName || this.$t('shared.supportingDocument').toString(),
                    isDeleted: false,
                })),
            };
            this.requestStatus = Number(result.requestStatus || result.RequestStatus || 0);
            this.model.isNormalProcessing = this.model.processingDuration == 1;
            this.model.isExpressProcessing = this.model.processingDuration == 2;
            this.model.templateExpiry = this.model.duration;
            this.getSenderType();
            this.concatenatedSenderTypes = this.senderType.map(type => this.getSenderTypeText(type)).join(', ');
            let parsedVariables: string[] | undefined;
            let parsedMaxLengths: number[] | undefined;
            let parsedTypes: string[] | undefined;
            if (this.model.templateContent) {
                try {
                    const parsed = JSON.parse(this.model.templateContent);
                    if (parsed && typeof parsed.text === 'string') {
                        parsedVariables = parsed.variables;
                        parsedMaxLengths = parsed.maxLengths;
                        parsedTypes = parsed.types;
                        this.model.templateContent = this.stripLoadedTemplateSuffix(parsed.text);
                    }
                } catch {
                    this.model.templateContent = this.stripLoadedTemplateSuffix(this.model.templateContent);
                }
            }
            this.syncVariablesFromTemplateContent(this.model.templateContent, parsedVariables, parsedMaxLengths, parsedTypes);
            await this.loadPreApprovedTemplates(this.model.classification);
            this.syncSelectedSuggestedTemplateVisualState();
            this.captureSuggestedFreeContentSnapshot();
        } else {
            Toaster.error(response.errorMessage);
        }
    }

    public async next() {
        if (this.stepNumber === 1) {
            if (!this.validateTemplateInfoStep()) {
                return;
            }
            this.prepareTemplateInfoForNextStep();
            if (this.isSuggestedFreeContentSelected || this.isAttachmentsOnlyEdit) {
                this.isAiValid = true;
                this.aiValidationRemarks = '';
                this.stepNumber = 2;
                return;
            }
            if (!this.isAiValid && this.aiValidationRemarks
                && this.model.templateContent === this.lastValidatedTemplateContent) {
                this.showAiContinueDialog();
                return;
            }
            const passed = await this.runAiValidation();
            if (passed) {
                this.stepNumber = 2;
            }
            return;
        }
        if (this.stepNumber < this.totalSteps) {
            this.stepNumber = this.stepNumber + 1;
        }
    }

    public back() {
        if (this.stepNumber === 2 && (this.isSuggestedFreeContentSelected || this.isAttachmentsOnlyEdit)) {
            this.stepNumber = 1;
            return;
        }
        if (this.stepNumber === 2) {
            this.resetTemplateCheck();
        }
        this.stepNumber = this.stepNumber - 1;
    }

    public cancel() {
        this.$router.push('/MessageTemplateDashboard');
    }

    public validateTemplateInfoStep(): boolean {
        if (!this.model.templateName.trim()) {
            Toaster.error(this.$t('shared.templateName').toString() + ' is required');
            return false;
        }
        if (!this.isTemplateDescriptionValid) {
            Toaster.error(this.templateDescriptionError);
            return false;
        }
        if (!this.model.classification) {
            Toaster.error(this.$t('shared.classification').toString() + ' is required');
            return false;
        }
        if (this.model.classification === 5 && !(this.model.companyName || '').trim()) {
            Toaster.error(this.$t('shared.companyNameRequired').toString());
            return false;
        }
        if (this.isSuggestedFreeContentSelected && !this.model.selectedTemplateId) {
            Toaster.error(this.$t('shared.selectSuggestedFreeTemplate').toString());
            return false;
        }
        if (!this.areVariableExamplesValid) {
            Toaster.error(this.$t('shared.variableExamplesRequired').toString());
            return false;
        }
        if (!this.isSuggestedFreeContentSelected && !this.model.templateContent.trim()) {
            Toaster.error(this.$t('shared.templateValue').toString() + ' is required');
            return false;
        }
        if (!this.isSuggestedFreeContentSelected
            && this.templateContentTotalCharacterCount < this.templateContentMinimumCharacterCount) {
            Toaster.error(this.$t('shared.templateCharacterCount', {
                count: this.templateContentTotalCharacterCount,
                min: this.templateContentMinimumCharacterCount,
            }).toString());
            return false;
        }
        if (!this.isSuggestedFreeContentSelected && this.hasInvalidVariableBoundary) {
            Toaster.error(this.$t('shared.templateVariableBoundaryInvalid').toString());
            return false;
        }
        if (!this.isSuggestedFreeContentSelected && this.hasTemplateVariables) {
            const errors = this.variableValidationErrors;
            if (errors.length > 0) {
                Toaster.error(errors[0]);
                return false;
            }
        }
        return true;
    }

    private prepareTemplateInfoForNextStep() {
        const currentDate = new Date();
        currentDate.setFullYear(currentDate.getFullYear() + (this.model.templateExpiry || 1));
        this.model.expiryDate = currentDate.toISOString().split('T')[0];
        this.model.isNormalProcessing = !this.model.isExpressProcessing;
    }

    private getTemplateContentWithoutVariables(content: string): string {
        return (content || '').replace(/#Var\d+#/gi, '');
    }

    public selectedTemplateDescription: string = '';

    public get isDescriptionDisabled(): boolean {
        return this.isSuggestedFreeContentSelected && !!this.selectedTemplateDescription;
    }

    public selectSuggestedTemplate(template: SuggestedTemplateModel) {
        this.$set(this.model, 'preApprovedTemplateId', template.id);
        this.$set(this.model, 'selectedTemplateId', template.id);
        this.model.templateName = template.name;
        this.selectedTemplateDescription = template.description || '';
        this.model.templateDescription = template.description || '';
        this.model.templateContent = template.content;
        this.syncVariablesFromTemplateContent(template.content, template.variableExamples, template.variableMaxLengths, template.variableTypes);
        this.lastValidatedTemplateContent = this.model.templateContent || '';
        this.lastAiFailureRemarks = '';
        this.aiValidationRemarks = '';
        this.resetTemplateCheck();
    }

    public deselectSuggestedTemplate() {
        this.$set(this.model, 'preApprovedTemplateId', '');
        this.$set(this.model, 'selectedTemplateId', '');
        this.model.templateName = '';
        this.selectedTemplateDescription = '';
        this.model.templateDescription = '';
        this.model.templateContent = '';
        this.templateVariableExamples = [];
        this.templateVariableMaxLengths = [];
        this.templateVariableTypes = [];
        this.lastValidatedTemplateContent = '';
        this.lastAiFailureRemarks = '';
        this.aiValidationRemarks = '';
        this.resetTemplateCheck();
    }

    private syncSelectedSuggestedTemplateVisualState() {
        const preApprovedId = this.model.preApprovedTemplateId || '';
        if (!preApprovedId) {
            this.$set(this.model, 'selectedTemplateId', '');
            this.selectedTemplateDescription = '';
            return;
        }
        this.$set(this.model, 'selectedTemplateId', preApprovedId);
        this.ensureSelectedSuggestedTemplateVisible();
        const matched = this.preApprovedTemplates.find(
            (template) => String(template.id) === String(preApprovedId),
        );
        if (matched) {
            this.selectedTemplateDescription = matched.description || '';
        }
    }

    private ensureSelectedSuggestedTemplateVisible() {
        const selectedId = this.model.preApprovedTemplateId || '';
        if (!selectedId) {
            return;
        }
        const exists = this.preApprovedTemplates.some(
            (template) => String(template.id) === String(selectedId),
        );
        if (exists) {
            return;
        }
        // Keep the existing selection visible when the template/classification
        // is no longer active and therefore absent from the API list.
        const selectedTemplate: SuggestedTemplateModel = {
            id: selectedId,
            templateCode: '',
            classification: this.model.classification,
            name: this.model.templateName || selectedId,
            description: this.model.templateDescription || '',
            content: this.model.templateContent || '',
            variableExamples: this.templateVariableExamples.slice(),
            variableMaxLengths: this.templateVariableMaxLengths.slice(),
            variableTypes: this.templateVariableTypes.slice(),
        };
        this.preApprovedTemplates = [selectedTemplate].concat(this.preApprovedTemplates);
    }

    private captureSuggestedFreeContentSnapshot() {
        const preApprovedTemplateId = this.model.preApprovedTemplateId || '';
        if (!preApprovedTemplateId) {
            this.loadedSuggestedFreeContentSnapshot = null;
            return;
        }
        this.loadedSuggestedFreeContentSnapshot = {
            preApprovedTemplateId,
            selectedTemplateId: this.model.selectedTemplateId || preApprovedTemplateId,
            templateContent: this.model.templateContent || '',
            templateDescription: this.model.templateDescription || '',
            templateName: this.model.templateName || '',
            templateVariableExamples: this.templateVariableExamples.slice(),
            selectedTemplateDescription: this.selectedTemplateDescription || '',
        };
    }

    public toggleSuggestedTemplate(template: SuggestedTemplateModel) {
        if (this.isSuggestedTemplateSelectionDisabled) {
            return;
        }
        if (this.isSuggestedTemplateSelected(template)) {
            this.deselectSuggestedTemplate();
            return;
        }
        this.selectSuggestedTemplate(template);
    }

    private syncVariablesFromTemplateContent(content: string, examples?: string[], maxLengths?: number[], types?: string[]) {
        const matches = [...(content || '').matchAll(/#Var(\d+)#/gi)];
        if (!matches.length) {
            this.templateVariableExamples = [];
            this.templateVariableMaxLengths = [];
            this.templateVariableTypes = [];
            return;
        }
        const maxIndex = Math.max(...matches.map((match) => parseInt(match[1], 10)));
        this.templateVariableExamples = Array.from({ length: maxIndex }, (_, index) => {
            const provided = examples && examples[index];
            if (provided && provided.trim()) {
                return provided.trim();
            }
            return this.getDefaultVariableExampleValue(index + 1);
        });
        this.templateVariableMaxLengths = Array.from({ length: maxIndex }, (_, index) => {
            if (maxLengths && maxLengths[index]) {
                return maxLengths[index];
            }
            const ex = this.templateVariableExamples[index];
            return ex ? ex.length : 0;
        });
        this.templateVariableTypes = Array.from({ length: maxIndex }, (_, index) => {
            const provided = types && types[index];
            if (provided && provided.trim()) {
                return provided.trim();
            }
            // Match addVariable default so loaded edit content can enable Next without retyping.
            return 'Letters & Numbers';
        });
    }

    private getDefaultVariableExampleValue(index: number): string {
        const defaults: { [key: number]: string } = {
            1: 'Customer',
            2: '123456',
            3: 'support@company.com',
        };
        return defaults[index] || `Var${index}Example`;
    }

    public addVariable() {
        if (this.areVariableActionsDisabled) {
            return;
        }
        if (!this.canUseGovernmentVariableException
            && this.templateVariableExamples.length >= TemplateVariableValidation.maxVariableCount) {
            Toaster.error(this.$t('shared.maxVariableCountExceeded', {
                count: TemplateVariableValidation.maxVariableCount,
            }).toString());
            return;
        }
        const nextIndex = this.templateVariableExamples.length + 1;
        const textarea = this.$refs.templateContent as HTMLTextAreaElement;
        const cursorPos = textarea ? textarea.selectionStart : (this.model.templateContent || '').length;
        const content = this.model.templateContent || '';
        const before = content.substring(0, cursorPos);
        const after = content.substring(cursorPos);
        if (!(before || '').trim()) {
            Toaster.error(this.$t('shared.templateMustNotStartOrEndWithVariable').toString());
            return;
        }
        if (/#Var\d+#\s*$/.test(before) || /^\s*#Var\d+#/.test(after)) {
            Toaster.error(this.$t('shared.adjacentVariablesNotAllowed').toString());
            return;
        }
        this.model.templateContent = `${before}#Var${nextIndex}#${after}`;
        this.ensureVariableExampleCount(nextIndex);
        this.ensureVariableMaxLengthCount(nextIndex);
        this.ensureVariableTypeCount(nextIndex);

        this.$set(this.templateVariableMaxLengths, nextIndex - 1, 0);
        this.$set(this.templateVariableTypes, nextIndex - 1, 'Letters & Numbers');
        this.$nextTick(() => {
            if (textarea) {
                const newCursorPos = cursorPos + `#Var${nextIndex}#`.length;
                textarea.setSelectionRange(newCursorPos, newCursorPos);
            }
        });
    }

    public deleteVariable(index: number) {
        if (this.areVariableActionsDisabled) {
            return;
        }
        this.templateVariableExamples.splice(index - 1, 1);
        this.templateVariableMaxLengths.splice(index - 1, 1);
        this.templateVariableTypes.splice(index - 1, 1);
        let content = this.model.templateContent || '';
        content = content.replace(new RegExp(`#Var${index}#`, 'gi'), '');
        const currentMax = this.templateVariableExamples.length + 1;
        for (let i = index + 1; i <= currentMax; i++) {
            content = content.replace(new RegExp(`#Var${i}#`, 'gi'), `#Var${i - 1}#`);
        }
        this.model.templateContent = content;
    }

    public getVariableExample(index: number): string {
        return this.templateVariableExamples[index - 1] || '';
    }

    public setVariableExample(index: number, value: string) {
        this.ensureVariableExampleCount(index);
        let truncated = value;
        const enteredMaxLength = this.templateVariableMaxLengths[index - 1];
        const maxExampleLength = enteredMaxLength && enteredMaxLength > 0
            ? enteredMaxLength
            : this.maxLengthInputMax;
        if (maxExampleLength !== undefined && truncated.length > maxExampleLength) {
            truncated = truncated.substring(0, maxExampleLength);
        }
        this.$set(this.templateVariableExamples, index - 1, truncated);
    }

    public onVariableExampleInput(index: number, event: Event) {
        const target = event.target as HTMLInputElement;
        if (!target) {
            return;
        }
        const sanitized = TemplateVariableValidation.sanitizeExampleForType(target.value, this.getVariableType(index));
        this.setVariableExample(index, sanitized);
        const stored = this.getVariableExample(index);
        if (target.value !== stored) {
            target.value = stored;
        }
    }

    public getVariableMaxLength(index: number): number | string {
        const value = this.templateVariableMaxLengths[index - 1];
        if (!value || value < 1) {
            return '';
        }
        return value;
    }

    public setVariableMaxLength(index: number, value: number) {
        this.ensureVariableMaxLengthCount(index);
        let clamped = Math.floor(value);
        if (isNaN(clamped) || clamped < 1) {
            this.$set(this.templateVariableMaxLengths, index - 1, 0);
            return;
        }
        const max = this.maxLengthInputMax;
        if (max !== undefined && clamped > max) {
            clamped = max;
        }
        this.$set(this.templateVariableMaxLengths, index - 1, clamped);
    }

    public onMaxLengthInput(index: number, event: Event) {
        const target = event.target as HTMLInputElement;
        if (!target || target.value === '') {
            this.setVariableMaxLength(index, 0);
            return;
        }
        const parsed = parseInt(target.value, 10);
        this.setVariableMaxLength(index, isNaN(parsed) ? 0 : parsed);
        const stored = String(this.getVariableMaxLength(index));
        if (target.value !== stored) {
            target.value = stored;
        }
    }

    private ensureVariableMaxLengthCount(index: number) {
        while (this.templateVariableMaxLengths.length < index) {
            this.templateVariableMaxLengths.push(0);
        }
    }

    public getVariableType(index: number): string {
        return this.templateVariableTypes[index - 1] || '';
    }

    public setVariableType(index: number, value: string) {
        this.ensureVariableTypeCount(index);
        this.$set(this.templateVariableTypes, index - 1, value);
        const example = this.getVariableExample(index);
        const sanitized = TemplateVariableValidation.sanitizeExampleForType(example, value);
        if (sanitized !== example) {
            this.setVariableExample(index, sanitized);
        }
    }

    private ensureVariableTypeCount(index: number) {
        while (this.templateVariableTypes.length < index) {
            this.templateVariableTypes.push('');
        }
    }

    public get hasMissingVariableTypes(): boolean {
        return this.templateVariableExamples.length > 0
            && (this.templateVariableTypes.length !== this.templateVariableExamples.length
                || this.templateVariableTypes.some((t) => !t));
    }

    public get variableTypeOptions(): Array<{value: string; label: string}> {
        return [
            { value: 'Numbers', label: this.$t('shared.variableTypeNumbers').toString() },
            { value: 'Letters', label: this.$t('shared.variableTypeLetters').toString() },
            { value: 'Letters & Numbers', label: this.$t('shared.variableTypeLettersAndNumbers').toString() },
            { value: 'Link', label: this.$t('shared.variableTypeLink').toString() },
        ];
    }

    public get hasSupportingDocumentAttachment(): boolean {
        return this.model.senderRequestAttachments.some(
            (a) => a.attachmentType === AttachmentCategoryType.SupportingDocument && !a.isDeleted,
        );
    }

    public get canUseGovernmentVariableException(): boolean {
        return this.model.customerType === 1 && this.hasSupportingDocumentAttachment;
    }

    public get maxLengthUpperBound(): number {
        return TemplateVariableValidation.maxLengthUpperBound;
    }

    public get maxLengthInputMax(): number | undefined {
        if (this.canUseGovernmentVariableException) {
            return undefined;
        }
        return TemplateVariableValidation.maxLengthUpperBound;
    }

    public get hasAdjacentVariables(): boolean {
        return /#Var\d+#\s*#Var\d+#/i.test(this.model.templateContent || '');
    }

    public get exceedsMaxVariableCount(): boolean {
        if (this.canUseGovernmentVariableException) {
            return false;
        }
        return this.templateVariableExamples.length > TemplateVariableValidation.maxVariableCount;
    }

    public get hasMaxLengthExceedingLimit(): boolean {
        if (this.canUseGovernmentVariableException) {
            return false;
        }
        return this.templateVariableMaxLengths.some((ml) => ml > TemplateVariableValidation.maxLengthUpperBound);
    }

    public get variableRatioPercent(): number {
        if (!this.templateVariableExamples.length) return 0;
        const totalMaxLength = TemplateVariableValidation.sumMaxLengths(this.templateVariableMaxLengths);
        const textContentLength = this.getTemplateContentWithoutVariables(this.fullTemplateContent).length;
        return TemplateVariableValidation.getDisplayRatioPercent(totalMaxLength, textContentLength);
    }

    public get exceeds40Percent(): boolean {
        if (!this.templateVariableExamples.length) return false;
        const totalMaxLength = TemplateVariableValidation.sumMaxLengths(this.templateVariableMaxLengths);
        const textContentLength = this.getTemplateContentWithoutVariables(this.fullTemplateContent).length;
        return TemplateVariableValidation.exceedsMaxRatio(totalMaxLength, textContentLength);
    }

    public get hasMissingMaxLength(): boolean {
        return this.templateVariableExamples.length > 0
            && (this.templateVariableMaxLengths.length !== this.templateVariableExamples.length
                || this.templateVariableMaxLengths.some((ml) => !ml || ml < 1));
    }

    public get hasEmptyVariableExamples(): boolean {
        return TemplateVariableValidation.hasEmptyExamples(this.templateVariableExamples);
    }

    public get hasMaxLengthLessThanExample(): boolean {
        return this.templateVariableExamples.some((example, index) => {
            const ml = this.templateVariableMaxLengths[index];
            return example && example.trim() && ml && ml < example.trim().length;
        });
    }

    public get maxLengthLessThanExampleLength(): number {
        for (let i = 0; i < this.templateVariableExamples.length; i++) {
            const example = this.templateVariableExamples[i];
            const ml = this.templateVariableMaxLengths[i];
            if (example && example.trim() && ml && ml < example.trim().length) {
                return example.trim().length;
            }
        }
        return 0;
    }

    public get hasVariableExampleTypeMismatch(): boolean {
        return this.templateVariableExamples.some((example, index) => {
            const type = this.templateVariableTypes[index];
            return !!example && !!type && !TemplateVariableValidation.isExampleValidForType(example, type);
        });
    }

    public get hasZeroTextContentWithVariables(): boolean {
        return this.hasTemplateVariables && this.templateContentTotalCharacterCount === 0;
    }

    public get variableValidationErrors(): string[] {
        const errors: string[] = [];
        if (this.hasAdjacentVariables) {
            errors.push(this.$t('shared.adjacentVariablesNotAllowed').toString());
        }
        if (this.exceedsMaxVariableCount) {
            errors.push(this.$t('shared.maxVariableCountExceeded', {
                count: TemplateVariableValidation.maxVariableCount,
            }).toString());
        }
        if (this.hasEmptyVariableExamples) {
            errors.push(this.$t('shared.variableExamplesRequired').toString());
        }
        if (this.hasMissingVariableTypes) {
            errors.push(this.$t('shared.variableTypeRequired').toString());
        }
        if (this.hasVariableExampleTypeMismatch) {
            errors.push(this.$t('shared.variableExampleTypeMismatch').toString());
        }
        if (this.hasZeroTextContentWithVariables) {
            errors.push(this.$t('shared.textContentRequiredWhenVariablesPresent').toString());
        }
        if (this.hasMaxLengthExceedingLimit) {
            errors.push(this.$t('shared.maxLengthExceeded', {
                max: TemplateVariableValidation.maxLengthUpperBound,
            }).toString());
        }
        if (this.hasMissingMaxLength) {
            errors.push(this.$t('shared.maxLengthRequired', {
                max: TemplateVariableValidation.maxLengthUpperBound,
            }).toString());
        }
        if (this.hasMaxLengthLessThanExample) {
            errors.push(this.$t('shared.maxLengthLessThanExample', {
                length: this.maxLengthLessThanExampleLength,
            }).toString());
        }
        if (this.exceeds40Percent) {
            errors.push(this.$t('shared.variablesMustNotExceed40Percent').toString());
        }
        return errors;
    }

    private ensureVariableExampleCount(index: number) {
        while (this.templateVariableExamples.length < index) {
            this.templateVariableExamples.push('');
        }
    }

    public onPickFile() {
        if (!this.canUploadMoreLicenseAttachments) {
            Toaster.error(this.$t('shared.maxLicenseAttachments').toString());
            return;
        }
        (this.$refs.fileName as HTMLInputElement).click();
    }

    private isPdfFile(file: File): boolean {
        return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
    }

    public onFilePicked(event: Event) {
        const input = event.target as HTMLInputElement;
        const files = input.files;
        if (!files || !files.length) {
            return;
        }
        const file = files[0];
        if (!this.isPdfFile(file)) {
            Toaster.error(this.$t('shared.pdfFilesOnly').toString());
            input.value = '';
            this.selectedFileName = '';
            return;
        }
        if (file.size > this.maxLicenseFileSizeBytes) {
            Toaster.error(this.$t('shared.fileSizeExceedsTheLimit').toString());
            input.value = '';
            this.selectedFileName = '';
            return;
        }
        this.selectedFileName = file.name;
        this.currentAttachment.file = file;
        const reader = new FileReader();
        reader.onloadend = (fileData: ProgressEvent<FileReader>) => {
            const result = fileData.target && fileData.target.result;
            if (typeof result === 'string') {
                this.currentAttachment.fileContent = result.split(',')[1];
                this.currentAttachment.fileName = file.name;
            }
        };
        reader.readAsDataURL(file);
        input.value = '';
    }

    public addAttachment() {
        if (!this.canUploadMoreLicenseAttachments) {
            Toaster.error(this.$t('shared.maxLicenseAttachments').toString());
            return;
        }
        this.currentAttachment.attachmentType = AttachmentCategoryType.SupportingDocument;
        this.currentAttachment.attachmentTypeName = this.$t('shared.supportingDocument').toString();
        this.model.senderRequestAttachments.push({ ...this.currentAttachment });
        this.currentAttachment = {
            id: '',
            fileName: '',
            fileContent: '',
            file: null,
            attachmentType: '',
            attachmentTypeName: '',
            isDeleted: false,
        };
        this.selectedFileName = '';
        if (this.fileNameRef) {
            this.fileNameRef.value = '';
        }
    }

    public deleteAttachment(index: number) {
        const visible = this.visibleAttachments;
        const attachment = visible[index];
        if (!attachment) {
            return;
        }
        if (attachment.id) {
            this.$set(attachment, 'isDeleted', true);
            return;
        }
        const realIndex = this.model.senderRequestAttachments.indexOf(attachment);
        if (realIndex >= 0) {
            this.model.senderRequestAttachments.splice(realIndex, 1);
        }
    }

    private stripLoadedTemplateSuffix(content: string): string {
        const clientName = (this.model.clientName || '').trim();
        const companyName = (this.model.companyName || '').trim();
        if (this.isAwarenessClassification && companyName) {
            const trimmed = (content || '').trim();
            const stripped = this.stripTemplateSuffix(trimmed, companyName);
            if (stripped !== trimmed) {
                return stripped;
            }
        }
        return this.stripTemplateSuffix(content, clientName);
    }

    private stripTemplateSuffix(content: string, suffix: string): string {
        const orgName = (suffix || '').trim();
        const trimmed = (content || '').trim();
        if (!orgName || !trimmed) {
            return trimmed;
        }
        const suffixWithSpace = ' ' + orgName;
        if (trimmed.toLowerCase().endsWith(suffixWithSpace.toLowerCase())) {
            return trimmed.slice(0, trimmed.length - suffixWithSpace.length).trimEnd();
        }
        if (trimmed.toLowerCase().endsWith(orgName.toLowerCase())) {
            return trimmed.slice(0, trimmed.length - orgName.length).trimEnd();
        }
        return trimmed;
    }

    private resetTemplateCheck() {
        this.responseMessage = '';
        this.responseSuccess = false;
        this.isAiValid = false;
    }

    @Watch('model.customerType', { deep: true })
    public onchangeCustomerType() {
        switch (this.model.customerType) {
            case 1:
                this.senderTypeList = [
                    { id: SenderType.Advertisement, name: this.$t('shared.advertisement').toString() },
                    { id: SenderType.Service, name: this.$t('shared.service').toString() },
                    { id: SenderType.Awareness, name: this.$t('shared.awareness').toString() },
                    { id: SenderType.Warning, name: this.$t('shared.warning').toString() },
                ];
                this.senderName = '';
                break;
            case 2:
                this.senderTypeList = [
                    { id: SenderType.Advertisement, name: this.$t('shared.advertisement').toString() },
                    { id: SenderType.Service, name: this.$t('shared.service').toString() },
                    { id: SenderType.Awareness, name: this.$t('shared.awareness').toString() },
                ];
                this.senderName = '';
                break;
            case 3:
                this.senderTypeList = [
                    { id: SenderType.Advertisement, name: this.$t('shared.advertisement').toString() },
                    { id: SenderType.Service, name: this.$t('shared.service').toString() },
                    { id: SenderType.Awareness, name: this.$t('shared.awareness').toString() },
                ];
                break;
            case 4:
                this.senderTypeList = [
                    { id: SenderType.Service, name: this.$t('shared.service').toString() },
                ];
                this.senderType = [SenderType.Service];
                break;
        }
    }

    @Watch('model.preApprovedTemplateId')
    public onSuggestedFreeContentChanged(isEnabled: boolean) {
        if (!isEnabled) {
            this.model.selectedTemplateId = '';
            this.model.templateContent = '';
            this.templateVariableExamples = [];
            this.templateVariableMaxLengths = [];
            this.templateVariableTypes = [];
            this.lastValidatedTemplateContent = '';
            this.lastAiFailureRemarks = '';
            this.aiValidationRemarks = '';
            this.resetTemplateCheck();
        }
    }

    @Watch('model.templateContent')
    public onTemplateContentChanged(newContent: string) {
        if (this.isSuggestedFreeContentSelected || this.isAttachmentsOnlyEdit) {
            return;
        }
        this.syncAiRemarksForContentEdit(newContent);
    }

    private syncAiRemarksForContentEdit(newContent: string): void {
        if ((newContent || '') !== this.lastValidatedTemplateContent) {
            this.aiValidationRemarks = '';
            return;
        }
        if (this.lastAiFailureRemarks) {
            this.aiValidationRemarks = this.lastAiFailureRemarks;
        }
    }

    @Watch('model.classification')
    public onClassificationChanged(newClassification: number, oldClassification: number) {
        if (this.isClassificationDisabled) {
            return;
        }
        if (oldClassification && newClassification !== oldClassification && this.isSuggestedFreeContentSelected) {
            this.deselectSuggestedTemplate();
        }
        if (newClassification !== 5) {
            this.model.companyName = '';
        }
        this.loadPreApprovedTemplates(newClassification);
    }

    private async loadPreApprovedTemplates(classification: number) {
        if (!classification) {
            this.preApprovedTemplates = [];
            return;
        }
        this.loadingPreApprovedTemplates = true;
        try {
            const response = await this.messageTemplateService.getPreApprovedTemplates(classification);
            if (response && response.isSuccess && response.result) {
                this.preApprovedTemplates = (response.result || []).map((item: any) => {
                    let contentText = '';
                    let variables: string[] = [];
                    let maxLengths: number[] = [];
                    let types: string[] = [];
                    let rawContent = item.templateContent || item.TemplateContent || '';
                    if (rawContent) {
                        try {
                            let parsed = JSON.parse(rawContent);
                            contentText = parsed.text || rawContent;
                            variables = parsed.variables || [];
                            maxLengths = parsed.maxLengths || [];
                            types = parsed.types || [];
                        } catch {
                            contentText = rawContent;
                        }
                    }
                    return {
                        id: item.id || item.Id,
                        templateCode: item.templateCode || item.TemplateCode || '',
                        classification: item.classification || item.Classification,
                        name: item.name || item.Name,
                        description: item.description || item.Description || '',
                        content: contentText,
                        variableExamples: variables,
                        variableMaxLengths: maxLengths,
                        variableTypes: types,
                    };
                });
            } else {
                this.preApprovedTemplates = [];
            }
        } catch {
            this.preApprovedTemplates = [];
        } finally {
            this.loadingPreApprovedTemplates = false;
            this.syncSelectedSuggestedTemplateVisualState();
        }
    }

    public showsubmitRequestDialog() {
        this.submitRequestdialog = true;
    }

    public hidesubmitRequestDialog() {
        this.submitRequestdialog = false;
    }

    public async submitRequest() {
        const preApprovedTemplateId = this.normalizePreApprovedTemplateId(this.model.preApprovedTemplateId);
        const payload = {
            Id: this.model.id,
            TemplateName: this.model.templateName,
            TemplateDescription: this.model.templateDescription || '',
            TemplateContent: JSON.stringify({
                text: this.fullTemplateContent,
                variables: this.templateVariableExamples,
                maxLengths: this.hasTemplateVariables ? this.templateVariableMaxLengths : [],
                types: this.hasTemplateVariables ? this.templateVariableTypes : [],
            }),
            SenderId: this.model.senderId,
            IsExpressProcessing: this.model.isExpressProcessing,
            ExpiryDate: this.model.expiryDate || null,
            Classification: this.normalizeClassification(this.model.classification) || null,
            CompanyName: this.model.companyName || '',
            PreApprovedTemplateId: preApprovedTemplateId || null,
            SenderRequestAttachments: (this.model.senderRequestAttachments || []).map((attachment) => ({
                Id: attachment.id || null,
                FileName: attachment.fileName,
                FileContent: attachment.fileContent || null,
                AttachmentType: attachment.attachmentType || AttachmentCategoryType.Other,
                IsDeleted: !!attachment.isDeleted,
            })),
        };
        const response = await this.UpdateContractRequestService.post(payload as any);
        if (response && response.isSuccess) {
            this.isSubmitted = true;
        } else {
            Toaster.error((response && response.errorMessage) || this.$t('shared.errorOccurred').toString());
        }
        this.hidesubmitRequestDialog();
    }

    public newRequest() {
        this.reset();
        this.stepNumber = 1;
    }

    public select(event: any, id: string) {
        if (!event) {
            const index = this.selectedIds.indexOf(id);
            this.selectedIds.splice(index, 1);
        } else {
            this.selectedIds.push(id);
        }
    }

    public getCustomerTypeText(typeId: number) {
        switch (typeId) {
            case 1: return this.$t('shared.government').toString();
            case 2: return this.$t('shared.charity').toString();
            case 3: return this.$t('shared.private').toString();
            case 4: return this.$t('shared.international').toString();
            default: return '-';
        }
    }

    public getClassificationText(typeId: number) {
        const normalizedId = this.normalizeClassification(typeId);
        const item = this.allClassifications.find((c) => c.id === normalizedId);
        if (item) {
            return item.name;
        }
        return normalizedId ? String(normalizedId) : '-';
    }

    private normalizeClassification(value: any): number {
        if (value === null || value === undefined || value === '') {
            return 0;
        }
        const asNumber = Number(value);
        if (!isNaN(asNumber) && asNumber > 0) {
            return asNumber;
        }
        const key = String(value).trim().toLowerCase();
        if (key === 'advertising') { return 1; }
        if (key === 'service') { return 2; }
        if (key === 'warning') { return 3; }
        if (key === 'awareness') { return 5; }
        return 0;
    }

    private normalizeSenderTypeFlags(value: any): number {
        if (value === null || value === undefined || value === '') {
            return 0;
        }
        const asNumber = Number(value);
        if (!isNaN(asNumber) && asNumber > 0) {
            return asNumber;
        }
        const key = String(value).trim().toLowerCase();
        if (key === 'advertisement') { return SenderType.Advertisement; }
        if (key === 'service') { return SenderType.Service; }
        if (key === 'awareness') { return SenderType.Awareness; }
        if (key === 'warning') { return SenderType.Warning; }
        return 0;
    }

    private normalizePreApprovedTemplateId(value: any): string {
        if (value === null || value === undefined || value === '') {
            return '';
        }
        const id = String(value);
        if (id === '00000000-0000-0000-0000-000000000000') {
            return '';
        }
        return id;
    }

    public getSenderType() {
        this.senderType = [];
        const senderBinary = this.normalizeSenderTypeFlags(this.model.senderType);
        if ((senderBinary & 1) === 1) {
            this.senderType.push(1);
        }
        if ((senderBinary & 2) === 2) {
            this.senderType.push(2);
        }
        if ((senderBinary & 4) === 4) {
            this.senderType.push(4);
        }
        if ((senderBinary & 8) === 8) {
            this.senderType.push(8);
        }
    }

    public getSenderTypeText(typeId: number) {
        switch (typeId) {
            case SenderType.Advertisement: return this.$t('shared.advertisement').toString();
            case SenderType.Service: return this.$t('shared.service').toString();
            case SenderType.Awareness: return this.$t('shared.awareness').toString();
            case SenderType.Warning: return this.$t('shared.warning').toString();
            default: return '-';
        }
    }

    private getTemplateValidationErrorMessage(response: any, axiosError?: AxiosError): string {
        const responseReason = response && response.result ? response.result.reason : '';
        const responseErrorMessage = response ? (response.errorMessage || response.ErrorMessage || '') : '';
        const apiErrorData: any = axiosError && axiosError.response ? axiosError.response.data : null;
        const apiErrorMessage = apiErrorData ? (apiErrorData.errorMessage || apiErrorData.ErrorMessage || apiErrorData.message || '') : '';
        const rawMessage = (responseReason || responseErrorMessage || apiErrorMessage || '').toString();
        if (!rawMessage) {
            return this.$t('shared.errorOccurred').toString();
        }
        if (rawMessage.toLowerCase().indexOf(this.noActiveRegulationMessage.toLowerCase()) !== -1) {
            return this.$t('shared.noActiveRegulationFoundForThisCategory').toString();
        }
        return rawMessage;
    }

    private startAiValidationLoading(): void {
        this.loadingAIValidation = true;
        this.aiValidationProgress = 0;
        clearInterval(this.aiValidationProgressInterval);
        this.aiValidationProgressInterval = setInterval(() => {
            if (this.aiValidationProgress < 98) {
                this.aiValidationProgress += 1;
            }
        }, 300);
    }

    private endAiValidationLoading(forceTo100: boolean): void {
        clearInterval(this.aiValidationProgressInterval);
        if (forceTo100) {
            this.aiValidationProgress = 100;
        }
        this.loadingAIValidation = false;
    }

    public showAiContinueDialog() {
        this.aiContinueDialog = true;
    }

    public hideAiContinueDialog() {
        this.aiContinueDialog = false;
    }

    public confirmAiContinue() {
        this.hideAiContinueDialog();
        this.stepNumber = 2;
    }

    public cancelAiContinue() {
        this.hideAiContinueDialog();
    }

    private async runAiValidation(): Promise<boolean> {
        this.startAiValidationLoading();
        try {
            return await this.checkMessageTemplate();
        } finally {
            this.endAiValidationLoading(true);
        }
    }

    async checkMessageTemplate(): Promise<boolean> {
        this.responseMessage = '';
        this.responseSuccess = false;
        this.isAiValid = false;
        this.aiValidationRemarks = '';
        try {
            this.validationModel.TemplateContent = (this.model.templateContent || '').trim();
            this.validationModel.Classification = this.model.classification;
            const response = await this.messageTemplateService.checkMessageTemplate(this.validationModel);
            this.lastValidatedTemplateContent = this.model.templateContent || '';
            if (response.isSuccess) {
                if (response.result.valid === true) {
                    this.responseSuccess = true;
                    this.isAiValid = true;
                    this.aiValidationRemarks = '';
                    this.lastAiFailureRemarks = '';
                    Toaster.success(this.$t('shared.templateValid').toString());
                    return true;
                } else {
                    this.responseSuccess = false;
                    this.isAiValid = false;
                    this.responseMessage = response.result.reason;
                    this.aiValidationRemarks = response.result.reason
                        || this.$t('shared.templateInvalid').toString();
                    this.lastAiFailureRemarks = this.aiValidationRemarks;
                    Toaster.error(this.$t('shared.aiCheckFailed').toString());
                    return false;
                }
            } else {
                this.responseSuccess = false;
                this.isAiValid = false;
                this.responseMessage = this.getTemplateValidationErrorMessage(response);
                this.aiValidationRemarks = this.responseMessage;
                this.lastAiFailureRemarks = this.aiValidationRemarks;
                Toaster.error(this.$t('shared.aiCheckFailed').toString());
                return false;
            }
        } catch (error) {
            const axiosError = error as AxiosError;
            this.responseSuccess = false;
            this.isAiValid = false;
            this.responseMessage = this.getTemplateValidationErrorMessage(null, axiosError);
            this.aiValidationRemarks = this.responseMessage;
            this.lastAiFailureRemarks = this.aiValidationRemarks;
            Toaster.error(this.$t('shared.aiCheckFailed').toString());
            return false;
        }
    }

    public get isValidStep(): boolean {
        if (this.stepNumber === 1) {
            const nameValid = this.model.templateName.trim() !== '';
            const expiryValid = this.model.templateExpiry !== 0;
            const companyNameValid = !this.isAwarenessClassification || (this.model.companyName || '').trim() !== '';
            if (this.isSuggestedFreeContentSelected) {
                return nameValid
                    && expiryValid
                    && companyNameValid
                    && !!this.model.selectedTemplateId
                    && this.areVariableExamplesValid;
            }
            const areVariablesValid = this.areVariableExamplesValid;
            const noVariableErrors = !this.hasTemplateVariables || this.variableValidationErrors.length === 0;
            return nameValid
                && expiryValid
                && companyNameValid
                && this.model.templateContent.trim() !== ''
                && this.templateContentTotalCharacterCount >= this.templateContentMinimumCharacterCount
                && areVariablesValid
                && noVariableErrors;
        }
        return true;
    }

    public reset() {
        const snapshot = this.loadedSuggestedFreeContentSnapshot;
        const preserveSuggestedFreeContent = !this.canSafelyReloadSuggestedFreeContent
            && !!snapshot
            && !!snapshot.preApprovedTemplateId;

        this.model = {
            id: this.id,
            duration: '1',
            startDate: '',
            clientName: this.model.clientName,
            crNumber: this.model.crNumber,
            enterpriseUnifiedNumber: this.model.enterpriseUnifiedNumber,
            customerType: this.model.customerType,
            senderName: this.model.senderName,
            requestType: 7,
            comment: this.model.comment,
            expiryDate: '',
            senderType: this.model.senderType,
            isNormalProcessing: true,
            isExpressProcessing: false,
            preApprovedTemplateId: preserveSuggestedFreeContent && snapshot ? snapshot.preApprovedTemplateId : '',
            selectedTemplateId: preserveSuggestedFreeContent && snapshot ? snapshot.selectedTemplateId : '',
            senderId: this.model.senderId,
            templateContent: preserveSuggestedFreeContent && snapshot ? snapshot.templateContent : '',
            templateDescription: preserveSuggestedFreeContent && snapshot ? snapshot.templateDescription : '',
            templateExpiry: 0,
            templateName: preserveSuggestedFreeContent && snapshot ? snapshot.templateName : '',
            processingDuration: 0,
            classification: this.model.classification,
            chanel: this.model.chanel,
            senderRequestAttachments: [],
            companyName: '',
        };
        this.contractAttachmentName = '';
        this.senderType = [];
        this.getSenderType();
        if (preserveSuggestedFreeContent && snapshot) {
            this.templateVariableExamples = snapshot.templateVariableExamples.slice();
            this.selectedTemplateDescription = snapshot.selectedTemplateDescription;
            this.ensureSelectedSuggestedTemplateVisible();
            this.syncSelectedSuggestedTemplateVisualState();
        } else {
            this.templateVariableExamples = [];
            this.selectedTemplateDescription = '';
            this.preApprovedTemplates = [];
            if (this.model.classification) {
                this.loadPreApprovedTemplates(this.model.classification);
            }
        }
        this.selectedFileName = '';
        this.currentAttachment = {
            id: '',
            fileName: '',
            fileContent: '',
            file: null,
            attachmentType: '',
            attachmentTypeName: '',
            isDeleted: false,
        };
        this.aiValidationRemarks = '';
        this.lastAiFailureRemarks = '';
        this.lastValidatedTemplateContent = '';
        this.isSubmitted = false;
        this.resetTemplateCheck();
    }
}
